import { NetworkAttackController } from '../controller/NetworkAttackController';
import { BaseWidgetWebComponent } from '../../widget/BaseWidgetWebComponent';

export class NetworkAttackWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: NetworkAttackController,
    });
  }
}
